export function initTrustpilot() {
    if (document.querySelector('.bg-trust-pilot')) {
        const tpScript = document.createElement('script');
        tpScript.type = 'text/javascript';
        tpScript.async = true;
        tpScript.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.sync.bootstrap.min.js';
        document.body.appendChild(tpScript);
    }
}